import React from 'react'
import Flex from 'typescript-styled-flex'
import { withTranslation } from 'react-i18next'
import Logo from '../../assets/logo-black.png'
import theme from '../../theme/theme'
import { is } from '../MediaQuery'
import useSize from '../../hooks/useSize'
import { IntegrationWrapper } from './Wrapper'
import { Circle } from './Circle'
import { StyledLogoImg } from './Logo'
import { Label } from './Label'
import { NumberLabel } from './NumberLabel'
import styled from '../../theme'
import { useDispatch, useSelector } from 'react-redux'
import { getUserCurrency } from '../../reducers/userObject/selectors/object'
import { toggleUpdateReservationModal } from '../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { EventStatus } from '../../models/Event'

const Label2 = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: bold;
  color: #272728;
  text-decoration: none solid rgb(39, 39, 40);
  display: contents;
`

const Label3 = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: #696a6d;
  margin-right: 15px;
  margin-left: -5px;
  font-weight: bold;
  text-decoration: none solid rgb(105, 106, 109);
`

const ClickLink = styled.span<{ disabled: boolean }>`
  cursor: pointer;
  text-decoration: underline;
  margin-right: 5.6px;
  &:hover {
    color: #0077bd;
  }
  ${(props) => (props.disabled ? 'opacity: 50%;' : '')};
`

const BBEngineBar = ({ t, groupReservations }) => {
  const isDesktop = is.desktop()
  const size = useSize()

  const currency = useSelector(getUserCurrency)
  const dispatch = useDispatch()
  const selectReservation = (id) => () => {
    dispatch(toggleUpdateReservationModal(id))
  }

  const withoutRemoved = groupReservations.filter((e) => !e.isDeleted)
  const withoutCancelled = withoutRemoved.filter(
    (e) => e.stage !== EventStatus.Canceled,
  )

  return (
    <Flex
      full={true}
      alignCenter={true}
      row={true}
      style={{
        background: '#ebedef',
        height: 'auto',
        minHeight: `${48 * size}px`,
        width: '100%',
      }}
    >
      <IntegrationWrapper
        size={size}
        style={{
          alignItems: isDesktop ? 'center' : 'flex-start',
          justifyContent: 'flex-start',
          flexDirection: isDesktop ? 'row' : 'column',
          maxHeight: isDesktop ? `${48 * size}px` : `${150 * size}px`,
        }}
      >
        <Flex>
          <Flex>
            <Circle size={size} color={theme.colors.palette.emerald} />
            <StyledLogoImg
              style={{ width: '16px', height: '16px' }}
              size={size}
              src={Logo}
              alt="logo bbengine"
            />
          </Flex>

          <Flex alignBaseline={true} wrap={false} justifyCenter={!isDesktop}>
            {isDesktop && <Label3>{t('BBO_3698_booking_engine')}</Label3>}

            {isDesktop && (
              <>
                <Label size={size}>{t('reservation_reservation_id')}</Label>
                <NumberLabel size={size}>
                  {withoutRemoved.map((r) => (
                    <ClickLink
                      disabled={r.stage === EventStatus.Canceled}
                      onClick={selectReservation(r.id)}
                    >
                      {'#' + r.id}
                    </ClickLink>
                  ))}
                </NumberLabel>
              </>
            )}

            <Label style={{ marginLeft: '5.6px' }} size={size}>
              {t('BBO_3698_total_number_of_rooms')}{' '}
              <Label2>{withoutCancelled.length} </Label2>
            </Label>

            <Label style={{ marginRight: '0px' }} size={size}>
              {t('BBO_3698_booking_engine_total_price')}{' '}
              <Label2>
                {withoutCancelled
                  .reduce((a, b) => Number(a) + Number(b.price), 0)
                  .toFixed(2)}{' '}
                {currency}
              </Label2>
            </Label>
          </Flex>
        </Flex>
        <Flex
          style={isDesktop ? {} : { marginTop: '5px', marginLeft: '15px' }}
          alignBaseline={true}
        >
          {!isDesktop && (
            <>
              <Label size={size}>{t('reservation_reservation_id')}</Label>
              <NumberLabel size={size}>
                {withoutRemoved.map((r) => (
                  <ClickLink
                    disabled={r.stage === EventStatus.Canceled}
                    onClick={selectReservation(r.id)}
                  >
                    {'#' + r.id}
                  </ClickLink>
                ))}
              </NumberLabel>
            </>
          )}
        </Flex>
      </IntegrationWrapper>
    </Flex>
  )
}

export default withTranslation()<any>(BBEngineBar)
